/**
 * What this node's logo is made of: the uploaded image if a superadmin set
 * one (Node settings → Branding), else the node's generated avatar — seeded
 * by nodeKey and tweaked by the stored avatar spec. Rendered by
 * components/Node/NodeLogo.jsx (navbar, public header) and turned into a
 * favicon by Routes/DocumentTitle.jsx.
 *
 * nodeKey is /info's node_id (federation id) when there is one, else its
 * node_name (the k8s namespace on a non-federated node): the former is what
 * peers seed this node's avatar from, so it has to win whenever it exists.
 *
 *   const { logoUrl, nodeKey, avatar, logoAlt } = useNodeLogo();
 */

import { useNodeInfo } from './use_node_info';
import { useNodeSettings } from './use_node_settings';

export function useNodeLogo() {
    const { nodeId, nodeName } = useNodeInfo();
    const { logoUrl, avatar } = useNodeSettings();
    return {
        logoUrl,
        nodeKey: nodeId || nodeName || null,
        avatar,
        // The tab title and the image's alt text. /info always sends a name;
        // "Vellby" only stands in while it is still loading.
        logoAlt: nodeName || 'Vellby',
    };
}

export default useNodeLogo;
